/** Configuración de la SPA (inyectada en build por studio.yml; en local, .env.local). */
export const ENV = {
  tenantId: import.meta.env.VITE_ENTRA_TENANT_ID,
  clientId: import.meta.env.VITE_ENTRA_CLIENT_ID,
  apiScope: import.meta.env.VITE_ENTRA_API_SCOPE,
  apiUrl: import.meta.env.VITE_API_URL,
  /** App de Entra PROPIA del simulador de conectores (appreg-skein-simulador,
      ADR-15): multi-organización y de solo lectura. Opcional: sin ella la
      pantalla dice qué falta y el banco de escenarios sigue funcionando. */
  simuladorClientId: import.meta.env.VITE_SIMULADOR_CLIENT_ID ?? "",
  /** Etiqueta de la sk-envline. */
  label: import.meta.env.VITE_API_URL.includes("api-pre") ? "pre" : import.meta.env.DEV ? "local" : "producción",
} as const;
